
    <div class="capture-content">
      <a
        href="#"
        (click)="$event.preventDefault(); reject(); stop()"
        class="icon close-popup"
        data-id="modalAlert-close-button"
      >
        <i class="fal fa-times"></i>
      </a>
      <div class="hidden-holder" [class.visible]="initiliaze && !cameraNotAllowed">
        <div class="capturer">
          <div class="outer">
            <div class="video">
              <canvas class="video-capture" #canvasElement [class.visible]="captured"></canvas>
              <video class="video-capture" autoplay #videoElement [class.visible]="!captured"></video>
              <div class="loader" *ngIf="!allowCapture">
                <app-loader [isLoading]="true"></app-loader>
                <br /><br />
                Waiting for your camera. Make sure your browser is not blocking it.
              </div>
            </div>
          </div>
          <div class="buttons">
            <ng-container *ngIf="!captured">
              <app-form-button class="primary width-100" (click)="capture()" [disabled]="!allowCapture"
                >Capture</app-form-button
              >
            </ng-container>
            <ng-container *ngIf="captured">
              <app-form-button (click)="captured = false">Retry</app-form-button>
              <app-form-button class="primary" (click)="submit()">Submit</app-form-button>
            </ng-container>
          </div>
        </div>
      </div>
      <ng-container *ngIf="!initiliaze">
        <div class="init-content">
          <p>
            We ask our customer to make selfie while holding uploaded document in their hand. <br />Your face and
            document must be fully seen and readable this photo.<br />
            Please click start and, when prompted, allow browser camera to proceed.
          </p>
          <app-form-button class="primary width-100" (click)="initializeCamera()">Start</app-form-button>
        </div>
      </ng-container>
      <ng-container *ngIf="cameraNotAllowed">
        <div class="init-content">
          <p>
            Camera does not have permissions to be runt on this website. Please allow it, try refreshing page or
            changing browsers and trying again.
          </p>
          <app-form-button class="primary width-100" (click)="initializeCamera()">Start</app-form-button>
        </div>
      </ng-container>
    </div>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/selfie-capture-modal.component.ts.SelfieCaptureModalComponent.html